interface ErrorMessageProps {
  message: string;
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  if (!message) return null;

  return (
    <div className="flex items-start">
      <p className="text-error text-sm">{message}</p>
    </div>
  );
}
